'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _ = require('../');

var _tokens = require('../styles/tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var overlayActionsMobileStyles = {
    flexFlow: 'column',
    '& button': {
        marginBottom: _tokens.spacingSmall,
        marginRight: 0,
        textAlign: 'center',
        width: _tokens.widthFluid,
        '&:last-child': {
            marginBottom: 0
        }
    }
};

var styles = function styles(theme) {
    return {
        actionRoot: _defineProperty({
            justifyContent: 'flex-start',
            margin: '0.7rem',
            '& button': {
                marginRight: _tokens.spacingSmall
            }
        }, '@media ' + _tokens.mqSmallDown, overlayActionsMobileStyles),
        actionsRight: _defineProperty({
            flexFlow: 'row-reverse',
            '& button': _defineProperty({
                marginLeft: _tokens.spacingSmall,
                marginRight: 0
            }, '@media ' + _tokens.mqSmallDown, {
                marginLeft: 0
            })
        }, '@media ' + _tokens.mqSmallDown, overlayActionsMobileStyles)
    };
};

/**
 * Use `SimpleDialog` to create a dialog, without having to explicitly specify each individual aspect of it.
 * @done true
 * @updated false
 * @versionAdded v0.0.13
 * @examples
 *  SimpleDialogExample
 *  SimpleDialogOverflowExample
 *  SimpleDialogResponsiveExample
 */

var SimpleDialog = function (_React$Component) {
    _inherits(SimpleDialog, _React$Component);

    function SimpleDialog() {
        _classCallCheck(this, SimpleDialog);

        return _possibleConstructorReturn(this, (SimpleDialog.__proto__ || Object.getPrototypeOf(SimpleDialog)).apply(this, arguments));
    }

    _createClass(SimpleDialog, [{
        key: 'componentDidMount',
        value: function componentDidMount() {

            // complain if caller gave us more than 3 buttons
            if (this.props.buttonConfig.length > 3) {
                console.warn('Dialogs should not have more than three buttons');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                DialogProps = _props.DialogProps,
                DialogActionsProps = _props.DialogActionsProps,
                DialogContentProps = _props.DialogContentProps,
                DialogTitleProps = _props.DialogTitleProps,
                rightAlignButtons = _props.rightAlignButtons,
                classes = _props.classes,
                maxWidth = _props.maxWidth,
                title = _props.title,
                showTitleBarClose = _props.showTitleBarClose,
                closeOnClickOut = _props.closeOnClickOut,
                fullScreen = _props.fullScreen,
                fullWidth = _props.fullWidth,
                buttonConfig = _props.buttonConfig,
                PaperProps = _props.PaperProps,
                children = _props.children;


            var actionClassOverrides = {
                root: classes.actionRoot
            };

            return _react2.default.createElement(
                _.Dialog,
                Object.assign({}, DialogProps, {
                    open: this.props.open,
                    onClose: this.props.onClose,
                    disableBackdropClick: !closeOnClickOut,
                    showTitleBarClose: showTitleBarClose,
                    fullScreen: fullScreen,
                    fullWidth: fullWidth,
                    PaperProps: PaperProps,
                    maxWidth: maxWidth
                }),
                title && _react2.default.createElement(
                    _.DialogTitle,
                    DialogTitleProps,
                    title
                ),
                _react2.default.createElement(
                    _.DialogContent,
                    DialogContentProps,
                    children
                ),
                _react2.default.createElement(
                    _.DialogActions,
                    Object.assign({}, DialogActionsProps, {
                        classes: actionClassOverrides,
                        'data-id': 'hed-simpleDialog-dialogActions',
                        className: (0, _classnames2.default)(_defineProperty({}, classes.actionsRight, rightAlignButtons)) }),
                    buttonConfig.map(function (config, index) {
                        return _react2.default.createElement(
                            _.Button,
                            {
                                color: index === 0 ? 'primary' : 'secondary',
                                key: config.id,
                                'data-key': config.id,
                                onClick: function onClick() {
                                    return _this2.props.handleButtonClick(config.id);
                                }
                            },
                            config.title
                        );
                    })
                )
            );
        }
    }]);

    return SimpleDialog;
}(_react2.default.Component);

;

SimpleDialog.muiName = 'SimpleDialog';

SimpleDialog.propTypes = {
    /**
     * The contents of the dialog.
     */
    children: _propTypes2.default.node.isRequired,
    /**
     * Props that will be applied to the `Dialog` element.
     */
    DialogProps: _propTypes2.default.object,
    /**
     * Props that will be applied to the `DialogActions` element.
     */
    DialogActionsProps: _propTypes2.default.object,
    /**
     * Props that will be applied to the `DialogContent` element.
     */
    DialogContentProps: _propTypes2.default.object,
    /**
     * Props that will be applied to the `DialogTitle` element.
     */
    DialogTitleProps: _propTypes2.default.object,
    /**
     * Whether the dialog is open
     */
    open: _propTypes2.default.bool.isRequired,
    /**
     * The dialog title.
     */
    title: _propTypes2.default.string,
    /**
     * The buttons to display in the action area. An array of objects with the following properties:
     *
     * * `id`: The button's unique identifier
     * * `title`: The button title
     *
     * Dialogs should have a maximum of three buttons.
     */
    buttonConfig: _propTypes2.default.arrayOf(_propTypes2.default.object),
    /**
     * If true, shows an 'x' in the title bar, which closes the dialog
     */
    showTitleBarClose: _propTypes2.default.bool,
    /**
     * If true, clicking outside the dialog will close it
     */
    closeOnClickOut: _propTypes2.default.bool,
    /**
     * Determine the max width of the dialog.
     *
     * The dialog width grows with the size of the screen, this property is useful
     * on the desktop where you might need some different widths across your
     * application.
     *
     * Valid values:
     *
     * * `xs`
     * * `sm`
     * * `md`
     * * `lg`
     * * `false` (disables max width)
     */
    maxWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', false]),
    /**
     * If `true`, the dialog stretches to `maxWidth`.
     */
    fullWidth: _propTypes2.default.bool,
    /**
     * If true, dialog will appear in full screen
     */
    fullScreen: _propTypes2.default.bool,
    /**
     * If true, the action buttons will be aligned right
     */
    rightAlignButtons: _propTypes2.default.bool,
    /**
     * Invoked when the dialog wants to close
     */
    onClose: _propTypes2.default.func,
    /**
     * Properties applied to the dialog's internal Paper element.
     */
    PaperProps: _propTypes2.default.object,
    /**
     * Invoked when the user clicks on one of the buttons. Is passed a single argument, the button id.
     */
    handleButtonClick: _propTypes2.default.func,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object
};

// default prop values
SimpleDialog.defaultProps = {
    showTitleBarClose: true,
    closeOnClickOut: true,
    fullScreen: false,
    fullWidth: false,
    rightAlignButtons: true,
    maxWidth: false,
    buttonConfig: []
};

exports.default = (0, _styles2.default)(styles)(SimpleDialog);